import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@dc-shared-web/components/shadcn/toast'
import { Icon, IconColor } from '@dc-shared-web/components/base/Icon'
import {
  faCheckCircle,
  faExclamationCircle,
} from '@document-crunch/pro-regular-svg-icons'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { useToast } from '@dc-shared-web/components/shadcn'
import { cn } from '@dc-shared-web/lib'

export function VssToaster({
  position = 'top',
}: {
  position?: 'top' | 'bottom'
}) {
  const { toasts } = useToast()
  const getIconColor = (
    variant: 'default' | 'success' | 'error' | null | undefined
  ): IconColor => {
    switch (variant) {
      case 'success':
        return IconColor.success
      case 'error':
        return IconColor.white
      default:
        return IconColor.darkPrimary
    }
  }
  const getIcon = (
    variant: 'default' | 'success' | 'error' | null | undefined
  ): IconDefinition => {
    switch (variant) {
      case 'success':
        return faCheckCircle
      case 'error':
        return faExclamationCircle
      default:
        return faCheckCircle
    }
  }

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const icon = getIcon(props.variant)
        const iconColor = getIconColor(props.variant)

        const hasTitleAndDescription = title && description
        const layoutClass = hasTitleAndDescription
          ? 'tw-flex tw-flex-col tw-gap-1'
          : 'tw-flex tw-items-center'
        return (
          <Toast data-testid='toast-message' key={id} {...props}>
            <div className='tw-flex tw-gap-6 tw-justify-between tw-w-full'>
              <div className='tw-flex tw-gap-2'>
                <Icon
                  icon={icon}
                  color={iconColor}
                  className={cn(
                    'tw-flex-shrink-0',
                    hasTitleAndDescription ? 'tw-mt-0.5' : 'tw-my-auto'
                  )}
                  style={{
                    //there is no 18px svg variant in fontawesome svgs
                    width: '18px',
                    height: '18px',
                  }}
                />
                <div className={layoutClass}>
                  {title && <ToastTitle>{title}</ToastTitle>}
                  {description && (
                    <ToastDescription>{description}</ToastDescription>
                  )}
                </div>
              </div>
              <div className='tw-flex tw-gap-4 tw-items-center'>
                <div>{action}</div>
                <ToastClose />
              </div>
            </div>
          </Toast>
        )
      })}
      <ToastViewport position={position} />
    </ToastProvider>
  )
}
